<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="main">
            <div class="container">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item v-for="(item, index) in policyList12" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="certificateInquiry">
                    <div class="title">查询结果</div>
                    <div class="card">
                        <!-- <div class="title">网络直播人才岗位能力提升证书</div> -->
                        <div class="title">{{ list.certName }}</div>
                        <div class="certificateInformation">
                            <div class="Photo">
                                <img :src="list.image" alt="">
                            </div>
                            <div class="information">
                                <div class="item">
                                    <div class="name">
                                        <div>姓</div>
                                        <div>名:</div>
                                    </div>
                                    <div>{{ list.username }}</div>
                                </div>
                                <div class="item">
                                    <div class="name">
                                        <div>证</div>
                                        <div>件</div>
                                        <div>号:</div>
                                    </div>
                                    <div>{{ list.idCard.replace(/(.{6}).*(.{2})/, '$1******$2') }}</div>
                                </div>
                                <div class="item">
                                    <div class="name">
                                        <div>证</div>
                                        <div>书</div>
                                        <div>编</div>
                                        <div>号:</div>
                                    </div>
                                    <div>{{ list.certCode }}</div>
                                </div>
                                <div class="item">
                                    <div class="name">
                                        <div>发</div>
                                        <div>证</div>
                                        <div>时</div>
                                        <div>间:</div>
                                    </div>
                                    <div>{{ list.signDate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="head">
            <img src="../../../assets/images/index/zjt.png" alt="" @click="fallback">
            <div>查询结果</div>
        </div>
        <div v-if="$store.state.settings.mode ==='mobile'" class="mobileMain">
            <div class="title">{{ list.certName }}</div>
            <div class="certificateInformation">
                <img :src="list.image" class="Photo" alt="">
                <div class="information">
                    <div class="item">
                        <div v-html="'姓&#8197;&#8197;&#8197;&#8197;&#8197;&#8197;名'" />
                        <div>:</div>
                        <div>{{ list.username }}</div>
                    </div>
                    <div class="item">
                        <div v-html="'证&#8197;&#8197;件&#8197;&#8197;号'" />
                        <div>:</div>
                        <div>{{ list.idCard.replace(/(.{6}).*(.{2})/, '$1******$2') }}</div>
                    </div>
                    <div class="item">
                        <div v-html="'证书编号'" />
                        <div>:</div>
                        <div>{{ list.certCode }}</div>
                    </div>
                    <div class="item">
                        <div v-html="'发证时间'" />
                        <div>:</div>
                        <div>{{ list.signDate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            policyList12: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '证件查询',
                    routerLink: 'certificateInquiry'
                },
                {
                    name: '查询结果'
                }
            ],
            list: {}
        }
    },
    mounted() {
        console.log('11111', this.$route.query.data)
        this.list = this.$route.query.data
    },
    methods: {
        fallback() {
            this.$router.go(-1)
        }
    }

}

</script>

<style lang="scss" scoped>

.main {
    background: #f4f5f7;
    padding-bottom: 30px;
    h1 {
        width: 100px;
    }
    .container {
        width: 1200px;
        margin: 0 auto;
        padding-top: 30px;
        span {
            font-size: 16px;
            font-weight: 400 !important;
            color: #999 !important;
            line-height: 50px;
            cursor: pointer;
            display: block;
            -moz-user-select: none; /* 火狐 */
            -webkit-user-select: none; /* webkit浏览器 */
            -ms-user-select: none; /* IE10 */
            -khtml-user-select: none; /* 早期浏览器 */
        }
        ul {
            list-style: none;
            width: 280px;
            display: flex;
            justify-content: space-between;
            padding-left: 0;
            li {
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 30px;
                cursor: pointer;
                -moz-user-select: none; /* 火狐 */
                -webkit-user-select: none; /* webkit浏览器 */
                -ms-user-select: none; /* IE10 */
                -khtml-user-select: none; /* 早期浏览器 */
                padding-left: 4px;
                &:last-child {
                    font-size: 16px;
                    font-weight: 400;
                    color: #333;
                    line-height: 30px;
                }
            }
        }
        .zcfg {
            width: 200px;
        }
        .contact-name {
            font-size: 30px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            width: 100%;
            display: block;
            text-align: center;
            margin-top: 50px;
            margin-bottom: 10px;
        }
        .contact-name-e {
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 30px;
            width: 100%;
            display: block;
            text-align: center;
        }
    }
    .certificateInquiry {
        background: #fff;
        text-align: center;
        padding: 60px 0 80px 0;
        .title {
            font-size: 20px;
            font-weight: 600;
            color: #243db3;
            padding-bottom: 40px;
        }
        .card {
            width: 640px;
            margin: auto;
            font-weight: 400;
            background: rgba(244, 245, 247, 0.5);
            border: 1px solid #eee;
            .title {
                font-size: 24px;
                color: #000;
                padding: 30px 0 35px 0;
            }
            .certificateInformation {
                display: flex;
                padding: 0 0 10px 40px;
                .Photo {
                    width: 136px;
                    height: 190px;
                    background: rgba(0, 0, 0, 0);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .information {
                    font-size: 18px;
                    font-weight: 400;
                    padding-left: 50px;
                    .item {
                        display: flex;
                        padding-bottom: 30px;
                        & > div:nth-of-type(1) {
                            color: #999;
                            padding-right: 15px;
                            width: 90px;
                            text-align: left;
                        }
                        & > div:nth-of-type(2) {
                            color: #000;
                        }
                    }
                }
            }
        }
    }
    ::v-deep .el-breadcrumb__inner {
        font-size: 16px;
        font-weight: 400 !important;
        color: #999 !important;
        line-height: 30px;
    }
}
.head {
    height: 60px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    img {
        width: 10px;
        height: 16px;
    }
    div {
        flex: 1;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        color: #000;
    }
}
.mobileMain {
    margin: 20px 15px 0;
    padding: 25px;
    background: rgba(244, 245, 247, 0.5);
    border: 1px solid #eee;
    .title {
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        color: #000;
    }
    .certificateInformation {
        display: flex;
        flex-direction: column;
        align-items: center;
        .Photo {
            width: 150px;
            height: 200px;
            object-fit: cover;
            margin: 20px 0 5px;
        }
        .item {
            display: flex;
            align-items: center;
            margin-top: 15px;
            div:nth-child(1) {
                width: 65px;
                font-size: 15px;
                font-weight: 400;
                color: #999;
            }
            div:nth-child(2) {
                font-size: 15px;
                font-weight: 400;
                color: #999;
            }
            div:nth-child(3) {
                font-size: 17px;
                margin-left: 20px;
                padding-left: 50px;
                .item {
                    display: flex;
                    padding-bottom: 30px;
                    // & > div:nth-of-type(1) {
                    //     color: #999;
                    //     padding-right: 15px;
                    //     width: 90px;
                    //     text-align: left;
                    // }
                    .name {
                        color: #999;
                        padding-right: 15px;
                        width: 80px;
                        display: flex;
                        justify-content: space-between;
                    }
                    & > div:nth-of-type(2) {
                        color: #000;
                    }
                }
            }
        }
    }
}
</style>
